module.exports = __webpack_public_path__ + "static/media/background_video.244bc533.jpg";